import { render, staticRenderFns } from "./Autorizar.vue?vue&type=template&id=22b60288"
import script from "./Autorizar.vue?vue&type=script&lang=js"
export * from "./Autorizar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports